import { inject, Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';

import { AppConfigService } from './app-config.service';
import { LABELS_FICHA_TECNICA } from '../../core/consts/labels-ficha-tecnica';

@Injectable({ providedIn: 'root' })
export class FichaTecnicaService {
    private static readonly PATH_ARQUIVO = '/ficha-tecnica/arquivo';
    private static readonly TEMPO_LIBERAR_URL_MS = 60_000;

    private readonly http = inject(HttpClient);
    private readonly appConfig = inject(AppConfigService);

    /**
     * Baixa o PDF da ficha vigente e o abre em outra aba. A aba é aberta de imediato, dentro do clique,
     * para não ser bloqueada como pop-up; ela recebe o PDF quando a resposta chega. Um `<a href>` direto
     * não serve porque não enviaria o `Authorization`.
     */
    public abrirEmNovaAba(): void {
        const aba = window.open('', '_blank');
        const url = `${this.appConfig.apiUrl()}${FichaTecnicaService.PATH_ARQUIVO}`;

        this.http.get(url, { responseType: 'blob' }).subscribe({
            next: (arquivo: Blob) => {
                const urlObjeto = URL.createObjectURL(arquivo);
                if (aba) {
                    aba.location.href = urlObjeto;
                } else {
                    window.open(urlObjeto, '_blank');
                }
                // A aba precisa de tempo para ler a URL antes de ela ser liberada.
                setTimeout(() => URL.revokeObjectURL(urlObjeto), FichaTecnicaService.TEMPO_LIBERAR_URL_MS);
            },
            error: (erro: HttpErrorResponse) => {
                console.error('Erro ao baixar a ficha técnica:', erro.status);
                aba?.close();
                window.alert(erro.status === 404 ? LABELS_FICHA_TECNICA.naoEncontrada : LABELS_FICHA_TECNICA.falha);
            },
        });
    }
}
